import * as React from "react";

export function useInView(element: any) {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        setIsVisible(true);
      }

      if (entry.intersectionRatio > 0) {
        observer.unobserve(entry.target);
      }
    });

    observer.observe(element.current);
  }, [element]);

  return isVisible;
}
